import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';
import UiMenuItem from './components/uiMenuItem';
import { colorsModeUI } from '../modeUI';
import { TYPE_MENU_ITEM_MENU, TYPE_MENU_ITEM_LINK } from '../constants';
import './index.css';

/**
 * Ui Menu
 * Display a menu using the Menu component from react semantic and the corresponding mode
 * Props (parameters)
 * @param bool vertical
 * @param array menu [
 *   string key
 *   string label
 *   string onClick
 *   string type [TYPE_MENU_ITEM_MENU, TYPE_MENU_ITEM_LINK]
 *   array items [{key, label, onClick}]
 * ]
 * @param string mode
 */
export default class UiMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.menuItems = this.menuItems.bind(this);
  }

  menuItems(items) {
    const { mode } = this.props;
    const styleMenu = {};
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      styleMenu.borderBottomColor = colors.MENU_SEPARATOR_COLOR;
      styleMenu.borderBottomWidth = '1px';
      styleMenu.borderBottomStyle = 'solid';
    }
    return items.map((item, index) => {
      switch (item.type) {
        case TYPE_MENU_ITEM_LINK:
          return (
            <UiMenuItem
              key={item.key}
              label={item.label}
              onClick={() => item.onClick()}
              mode={mode}
            />
          );
        case TYPE_MENU_ITEM_MENU:
          return (
            <Menu.Item
              key={item.key}
              style={{ ...(index < items.length - 1 ? styleMenu : {}) }}
            >
              <Menu.Header>{item.label}</Menu.Header>
              <Menu.Menu key={item.key}>{this.menuItems(item.items)}</Menu.Menu>
            </Menu.Item>
          );
        default:
          return null;
      }
    });
  }

  render() {
    const { vertical, menu, mode } = this.props;
    const styleMenu = {};
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      styleMenu.backgroundColor = colors.MENU_BACKGROUND_COLOR;
      styleMenu.color = colors.MENU_ITEM_COLOR;
    }
    return (
      <Menu
        vertical={vertical}
        style={styleMenu}
        className={`${mode !== null ? 'ui-menu' : ''}`}
      >
        {this.menuItems(menu)}
      </Menu>
    );
  }
}

UiMenu.propTypes = {
  vertical: PropTypes.bool,
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
      type: PropTypes.string,
      items: PropTypes.arrayOf(Object),
    })
  ).isRequired,
  mode: PropTypes.string,
};

UiMenu.defaultProps = {
  vertical: false,
  mode: null,
};
